import { makeStyles } from "@material-ui/core";
import { useReducer } from "react";
import { StockLocationRegister } from "./StockLocation";

import CustomTabStyle from "../../componentes/tabs/CustomTabStyle";
import CustomTabs from "../../componentes/tabs/CustomTabs";
import CallOutlinedIcon from "@material-ui/icons/CallOutlined";
import MailOutlineIcon from "@material-ui/icons/MailOutlineOutlined";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import SearchIcon from "@material-ui/icons/Search";
import { useTranslation } from "react-i18next";
import a11yProps from "../../componentes/tabs/a11Props";
import TabPanel from "../../componentes/tabs/TabPanel";
import FormContainer from "../../componentes/form-container/FormContainer";
import { StockLocationStorage } from "./StockLocationStorage";
import { StockLocationStreet } from "./StockLocationStreet";
import { StockLocationColumn } from "./StockLocationColumn";
import { StockLocationLevel } from "./StockLocationLevel";
import { BarChartOutlined, ViewColumnOutlined } from "@material-ui/icons";

/**
 * Author : AndréK
 * 26/08/2022
*/
const useStyles = makeStyles((theme) => ({
    root: {
        marginRight: 10,
    },
}));

const reducer = (state, data) => {
    return { ...state, ...data }
}

const initialState = {
    id: 0,
    tabValue: 0,
};

const StockLocationControl = () => {

    const { t } = useTranslation();
    const classes = useStyles();
    const [state, dispatch] = useReducer(reducer, initialState);
    const { id, tabValue } = state
    const handleTabChange = (event, newValue) => dispatch({ tabValue: newValue });

    return (
        <>
            <FormContainer>
                <CustomTabs
                    value={tabValue}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="stockLocation tab"
                >
                    <CustomTabStyle
                        label={t("stockLocation")}
                        {...a11yProps(0)}
                        icon={<SearchIcon fontSize="small" classes={classes} />} />
                    <CustomTabStyle
                        label={t("storage")}
                        {...a11yProps(1)}
                        icon={<HomeOutlinedIcon fontSize="small" classes={classes} />} />
                    <CustomTabStyle
                        label={t("street")}
                        {...a11yProps(2)}
                        icon={<MailOutlineIcon fontSize="small" classes={classes} />} />
                    <CustomTabStyle
                        label={t("column")}
                        {...a11yProps(3)}
                        icon={<ViewColumnOutlined fontSize="small" classes={classes} />} />
                    <CustomTabStyle
                        label={t("level")}
                        {...a11yProps(3)}
                        icon={<BarChartOutlined fontSize="small" classes={classes} />} />
                </CustomTabs>
                <TabPanel value={tabValue} index={0}>
                    <StockLocationRegister updateId={dispatch} />
                </TabPanel>
                <TabPanel value={tabValue} index={1}>
                    <StockLocationStorage idStockLocation={id} />
                </TabPanel>
                <TabPanel value={tabValue} index={2}>
                    <StockLocationStreet idStockLocation={id} />
                </TabPanel>
                <TabPanel value={tabValue} index={3}>
                    <StockLocationColumn idStockLocation={id} />
                </TabPanel>
                <TabPanel value={tabValue} index={4}>
                    <StockLocationLevel idStockLocation={id} />
                </TabPanel>
                
            </FormContainer>
        </>
    )
}

export default StockLocationControl;